import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { CfopRequest, Response } from './Types';

class CfopController {
  public static async Listar(request: CfopRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/cfop/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(cfop_id: number): Promise<Response> {
    try {
      console.log('Controller Cliente Listar Unico');
      console.log(cfop_id);

      const response = await Api.get(`api/cfop/ListarUnico/${cfop_id}`);      

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Gravar(request: CfopRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/cfop/Gravar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;

    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: CfopRequest): Promise<Response> {
    try {
      console.log('Controller CFOP Atualizar');
      console.log(request);

      const response = await Api.put(`api/cfop/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: CfopRequest): Promise<Response> {
    try {
      console.log('Controller CFOP Excluir');
      console.log(request);

      const response = await Api.put(`api/cfop/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      console.log(retorno);
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default CfopController;
